import { featureFlagFlags } from '@/plugins/rollout';
import { createApi } from '@stilingue/st-auth-utils';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import Service from '../Service';
import gateway from '../Gateway';
import { mockPublicationsOverTimeWithDistribution } from '@/utils/mocks/publications-over-time-with-distribution.js';

const version = isProdVersion()
  ? featureFlagFlags.ChartsServiceVersionProd.getValue()
  : featureFlagFlags.ChartsServiceVersionStaging.getValue();

const afterParser = (response) => response.data;

class ChartsService extends Service {
  constructor(gateway, version) {
    const api = createApi(`benchmarks-charts-service/${version}/`, gateway);

    super(api, {
      afterParser,
      retriesLimit: 3,
    });

    this.api.http.defaults.timeout = 300000;
  }

  getFollowersByChannel(params = {}) {
    return this.find({
      params,
      url: 'followers-by-channel',
    });
  }

  getFanbaseEvolution(params = {}) {
    return this.find({
      params,
      url: 'followers/group-evolution',
    });
  }

  getFanbaseEvolutionTable(params = {}) {
    return this.find({
      params,
      url: 'followers/group-evolution-info',
    });
  }

  getTotalPublications(params = {}) {
    return this.find({
      params,
      url: 'posts/by-groups',
    });
  }

  getPublicationsByMediaType(params = {}) {
    return this.find({
      params,
      url: 'posts/by-content-types',
    });
  }

  getInteractionsAndEngagementRate(params = {}) {
    return this.find({
      params,
      url: 'interactions/by-engagement-rates',
    });
  }

  getInteractionsOverTime(params = {}) {
    return this.find({
      params,
      url: 'interactions/over-times',
    });
  }

  getInteractionsByMediaType(params = {}) {
    return this.find({
      params,
      url: 'interactions/by-content-types',
    });
  }

  getInteractionsBySocialNetwork(params = {}) {
    return this.find({
      params,
      url: 'interactions/by-channels',
    });
  }

  getAverageInteractionsByPublication(params = {}) {
    return this.find({
      params,
      url: 'interactions/avg/by-posts',
    });
  }

  getEngagementOverTime(params = {}) {
    return this.find({
      params,
      url: 'engagements/over-times',
    });
  }

  getSentimentsInTheComments(params = {}) {
    return this.find({
      params,
      url: 'sentiments/in-the-comments/by-group',
    });
  }

  getEngagementMatrix(params = {}) {
    return this.find({
      params,
      url: 'matrix/polarity-by-engagement',
    });
  }

  getDistributionOfInteractions(params = {}) {
    return this.find({
      params,
      url: 'interactions/of-distribution',
    });
  }

  getTermsMentioned(params = {}) {
    return this.find({
      params,
      url: 'terms-mentioned/of-comments/by-group',
    });
  }

  getSentimentsInTheCommentsOverTime(params = {}) {
    return this.find({
      params,
      url: 'sentiments/in-the-comments/over-times',
    });
  }

  getPublicationsOverTimeWithDistribution(params = {}) {
    console.log(this, 'this/getPublicationsOverTimeWithDistribution');
    console.log(params, 'params/getPublicationsOverTimeWithDistribution');

    return new Promise((resolve) => setTimeout(resolve, 5000, mockPublicationsOverTimeWithDistribution));
  }

  getTopPublications(params = {}) {
    return this.api.get({
      params,
      url: 'posts/data/by-groups',
    });
  }
}

export default new ChartsService(gateway, version);
